import styled from 'styled-components';
import { Orientation, DeviceType, Platform } from 'sofa-reborn-react';
import { SkapaTheme } from '@inter-ikea-kompis/themes';
import { IframeUtility } from '@inter-ikea-kompis/utilities';

export const StyledSummaryPage = styled.div<{
	hide: boolean;
	platform: Platform;
	deviceType: DeviceType;
	orientation: Orientation;
	noSummaryPageBackButton: boolean;
	showBanner: boolean;
	bannerHasBeenShown: boolean;
}>`
	position: absolute;
	height: ${IframeUtility.isInsideIframe() ? 'auto' : '100vh'};
	width: 100%;
	min-height: ${(props) => (props.noSummaryPageBackButton ? 'auto' : '750px')};
	top: 0;
	bottom: ${(props) => (props.platform === 'kiosk' ? '0' : 'auto')};
	left: 0;
	right: 0;
	display: ${(props) => (props.hide ? 'none' : 'flex')};
	flex-direction: column;
	align-items: center;
	justify-content: space-between;
	z-index: 5;
	background-color: ${SkapaTheme.color.neutral.white};
	box-sizing: border-box;
	border-top: ${(props) =>
		props.platform === 'kiosk' ? 'none' : '1px solid ' + SkapaTheme.color.border.default};
	border-bottom: ${(props) =>
		props.showBanner && !props.bannerHasBeenShown
			? '1px solid' + SkapaTheme.color.border.default + ';'
			: 'none'};
	overflow: ${(props) =>
		IframeUtility.isInsideIframe() && props.platform === 'web' ? 'visible' : 'auto'};
	margin: 0px auto;
`;

export const SummaryPageSection = styled.div<{
	noBack: boolean | null;
}>`
	${(props): string => {
		if (props.noBack) {
			return `
				display: inline;
			`;
		} else {
			return `
				width: 100%;
			`;
		}
	}}
`;
